import type { CoreConfig } from "@/core"
import type { EmailConfig } from "@/email"

export const userRoles = ["powerup"] as const

export type Config = CoreConfig & EmailConfig

const config: Config = {
  core: {
    supportEmail: "support@pagezero.dev",
    websiteUrl: "https://pagezero.dev",
    projectName: "PageZERO",
    darkMode: true,
    appTitle: "PageZERO - Open source TanStack Start boilerplate for Cloudflare",
    appDescription:
      "An open source TanStack Start boilerplate for Cloudflare. Auth, payments, email, permissions, and more - wired together. Free forever. Cheap to run. Own every line of code.",
    appKeywords: [
      "tanstack start cloudflare",
      "tanstack start template",
      "tanstack start boilerplate",
      "cloudflare workers template",
      "cloudflare workers starter",
      "open source tanstack start",
      "open source cloudflare starter",
      "open source cloudflare boilerplate",
      "saas starter kit",
      "open source saas",
      "open source saas starter",
      "open source boilerplate",
      "boilerplate saas",
      "cloudflare boilerplate",
      "cloudflare starter",
      "saas boilerplate",
    ],
  },
  email: {
    from: "PageZERO <notify@notify.pagezero.dev>",
  },
  // permissions: {
  //   roleToPermissions: {
  //     powerup: {
  //       accessPowerup: true,
  //     },
  //   },
  // },
  // payments: {
  //   products: {
  //     powerup: {
  //       name: "powerup",
  //       userRoleToGrant: "powerup",
  //       polarProductId: {
  //         preview: "a42e49df-e2e1-4442-aac7-cf0a407199d0",
  //         production: "1da1058c-a0dc-4019-95f7-5434977d99c6",
  //       },
  //       checkoutLink: {
  //         preview:
  //           "https://sandbox-api.polar.sh/v1/checkout-links/polar_cl_zSxpokBJ5ulkvvHyNgRLy9OTSSkOEzPzrAyBb3Ja679/redirect",
  //         production:
  //           "https://buy.polar.sh/polar_cl_3swFuyz7urjS89uu4nu9Q22R0guHzasdl0omZ2DqRbB",
  //       },
  //     },
  //   },
  // },
}

export default config
